import React, { useEffect, useState } from "react";
import StickyTitle from '../components/StickyTitle'
import ReactToPrint from "react-to-print";
import {
    InputLabel,
    Select,
    MenuItem,
    FormControl,
    Button
} from "@mui/material";
import companylogo from "../../assets/company.png"


const PaymentsReportPage = () => {

    const [clientpaymentdata, setclientpaymentdata] = useState([]);
    const [vendorpaymentdata, setvendorpaymentdata] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [paymentType, setPaymentType] = useState("");
    const [filteredClientPayments, setFilteredClientPayments] = useState();
    const [filteredVendorPayments, setFilteredVendorPayments] = useState();
    const [paymentTypeSelected, setPaymentTypeSelected] = useState("client");

    const componentRef = React.createRef();

    useEffect(() => {
        const fetchClientPayments = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_BASE_URL}/payments/all_payments`
                );
                const responseData = await response.json();
                if (responseData) {
                    setclientpaymentdata(responseData.payment)
                }
            } catch (error) {
                console.log(error.message);
            }
        };
        const fetchVendorPayments = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_BASE_URL}/vendors/all_vendorpayments`
                );
                const responseData = await response.json();
                if (responseData) {
                    setvendorpaymentdata(responseData.vendors)
                }
            } catch (error) {
                console.log(error.message);
            }
        };

        fetchClientPayments();
        fetchVendorPayments();
    }, []);


    useEffect(() => {
        let filteredData = clientpaymentdata;

        if (fromDate && toDate) {
            filteredData = filteredData.filter(payment => payment.paymentdate >= fromDate && payment.paymentdate <= toDate);
        }

        if (paymentType) {
            filteredData = filteredData.filter(payment => payment.paymenttype === paymentType);
        }

        setFilteredClientPayments(filteredData);
    }, [clientpaymentdata, fromDate, toDate, paymentType]);


    useEffect(() => {
        let filteredData = vendorpaymentdata;

        if (fromDate && toDate) {
            filteredData = filteredData.filter(payment => payment.paymentdate >= fromDate && payment.paymentdate <= toDate);
        }

        if (paymentType) {
            filteredData = filteredData.filter(payment => payment.paymenttype === paymentType);
        }

        setFilteredVendorPayments(filteredData);
    }, [vendorpaymentdata, fromDate, toDate, paymentType]);


    const handleToggle = (type) => {
        setPaymentTypeSelected(type);
        setFromDate("");
        setToDate("");
        setPaymentType("");
    };

    const calculateTotalPayments = (payments) => {
        return payments && payments?.reduce((total, payment) => total + parseInt(payment.amountstatus), 0);
    };

    return (
        <>
            <StickyTitle no_button={true} title="Payment Reports" />
            <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>

                <div className="w-full flex flex-row justify-center items-center">
                    <Button
                        variant={paymentTypeSelected === "client" ? "contained" : "outlined"}
                        onClick={() => handleToggle("client")}
                    >
                        Client Receiving Voucher
                    </Button>
                    <Button
                        variant={paymentTypeSelected === "vendor" ? "contained" : "outlined"}
                        onClick={() => handleToggle("vendor")}
                    >
                        Vendor Payments
                    </Button>
                </div>

                {paymentTypeSelected === "client" && (
                    <>
                        <div className="table-filters flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between mt-3 mb-">
                            <div className='text-2xl ml-2 font-bold font-poppins'>Receiving Reports For Clients</div>
                        </div>
                        <main className="m-5 p-5 xl:grid grid-cols-1 gap-10 xl:items-start">
                            <section>
                                <div className="bg-white p-5 rounded shadow">
                                    <div className="flex flex-col justify-center">
                                        <Button onClick={() => {
                                            setFromDate('')
                                            setFromDate('')
                                            setPaymentType('')
                                        }} variant="contained" disableElevation>
                                            Clear Filters
                                        </Button>
                                        <InputLabel>From Date</InputLabel>
                                        <FormControl>
                                            <input type="date" onChange={(e) => setFromDate(e.target.value)} />
                                        </FormControl>
                                        <InputLabel>To Date</InputLabel>
                                        <FormControl>
                                            <input type="date" onChange={(e) => setToDate(e.target.value)} />
                                        </FormControl>
                                        <InputLabel>Payment Type</InputLabel>
                                        <FormControl>
                                        <InputLabel>Select Type</InputLabel>
                                            <Select
                                                value={paymentType}
                                                onChange={(e) => setPaymentType(e.target.value)}
                                            >
                                                <MenuItem value="">All</MenuItem>
                                                <MenuItem value="Cash">Cash</MenuItem>
                                                <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                                                <MenuItem value="Cheque">Cheque</MenuItem>
                                            </Select>
                                        </FormControl>

                                        <ReactToPrint
                                            trigger={() => (
                                                <button className="bg-green-500 mt-5 text-white font-bold py-2 px-4 rounded hover:bg-green-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-green-400">
                                                    Generate Report
                                                </button>
                                            )}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                </div>
                            </section>

                            {/* Invoice Preview */}
                            <div className="invoice__preview bg-white p-5 rounded-2xl border-4 border-blue-200  ">
                                <ReactToPrint
                                    trigger={() => (
                                        <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                                            Print / Download
                                        </button>
                                    )}
                                    content={() => componentRef.current}
                                />
                                <div
                                    ref={componentRef}
                                    className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative"
                                >
                                    <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                                        <div>

                                            <img  src={companylogo} alt="logo" />
                                        </div>
                                    </div>
                                    <article className=" py-2 text-center text-base text-black border-t border-black uppercase w-full font-bold">
                                        <p>Client Receiving Report</p>
                                    </article>

                                    <table width="100%" className="mb-10">
                                        <thead>
                                            <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                                <td className="font-bold">Client ID</td>
                                                <td className="font-bold">Client Name</td>
                                                <td className="font-bold">Date</td>
                                                <td className="font-bold">Payment Type</td>
                                                <td className="font-bold">Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredClientPayments && filteredClientPayments?.map((payment) => (
                                                <tr className=" text-center h-10" key={payment.id}>
                                                    <td>{payment.clientid}</td>
                                                    <td>{payment.clientinvoice}</td>
                                                    <td>{payment.paymentdate}</td>
                                                    <td>
                                                        {payment.paymenttype}
                                                        {payment.chequenumber ? ' No. ' + payment.chequenumber : ''}
                                                        {payment.refnumber ? ' Ref. No. ' + payment.refnumber : ''}
                                                    </td>                                                    
                                                    <td>{payment.amountstatus}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <tr className=" text-center bg-gray-100 p-1 py-2 mb-10 text-center text-base text-black border-t border-b border-black uppercase w-full font-semibold" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <td className=" font-bold text-md text-center" colSpan={2}>
                                            Total Payments: {calculateTotalPayments(filteredClientPayments)}
                                        </td>
                                    </tr>
                                    <tr className=" text-center h-10 font-bold mt-2">
                                        <td className=" font-bold text-lg border-t border-black text-center" colSpan={2}>
                                            Accountant
                                        </td>
                                    </tr>


                                </div>
                            </div>
                        </main>
                    </>
                )}

                {paymentTypeSelected === "vendor" && (
                    <>
                        <div className="table-filters flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between mt-3 mb-">
                            <div className='text-2xl ml-2 font-bold font-poppins'>Payment Reports For Vendors</div>
                        </div>
                        <main className="m-5 p-5 xl:grid grid-cols-1 gap-10 xl:items-start">
                            <section>
                                <div className="bg-white p-5 rounded shadow">
                                    <div className="flex flex-col justify-center">
                                        <Button onClick={() => {
                                            setFromDate('')
                                            setFromDate('')
                                            setPaymentType('')
                                        }} variant="contained" disableElevation>
                                            Clear Filters
                                        </Button>
                                        <InputLabel>From Date</InputLabel>
                                        <FormControl>
                                            <input type="date" onChange={(e) => setFromDate(e.target.value)} />
                                        </FormControl>
                                        <InputLabel>To Date</InputLabel>
                                        <FormControl>
                                            <input type="date" onChange={(e) => setToDate(e.target.value)} />
                                        </FormControl>
                                        <InputLabel>Payment Type</InputLabel>
                                        <FormControl>
                                        <InputLabel>Select Type</InputLabel>
                                            <Select
                                                value={paymentType}
                                                onChange={(e) => setPaymentType(e.target.value)}
                                               
                                            >
                                                <MenuItem value="">All</MenuItem>
                                                <MenuItem value="Cash">Cash</MenuItem>
                                                <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                                                <MenuItem value="Cheque">Cheque</MenuItem>
                                            </Select>
                                        </FormControl>

                                        <ReactToPrint
                                            trigger={() => (
                                                <button className="bg-green-500 mt-5 text-white font-bold py-2 px-4 rounded hover:bg-green-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-green-400">
                                                    Generate Report
                                                </button>
                                            )}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                </div>
                            </section>

                            {/* Invoice Preview */}
                            <div className="invoice__preview bg-white p-5 rounded-2xl border-4 border-blue-200  ">
                                <ReactToPrint
                                    trigger={() => (
                                        <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                                            Print / Download
                                        </button>
                                    )}
                                    content={() => componentRef.current}
                                />
                                <div
                                    ref={componentRef}
                                    className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative"
                                >
                                    <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                                        <div>

                                            <img  src={companylogo} alt="logo" />
                                        </div>
                                    </div>
                                    <article className=" py-2 text-center text-base text-black border-t border-b border-black uppercase w-full font-bold">
                                        <p>Vendor Payments Report</p>
                                    </article>
                                    <table width="100%" className="mb-10">
                                        <thead>
                                            <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                                <td className="font-bold">Vendor ID</td>
                                                <td className="font-bold">Vendor Name</td>
                                                <td className="font-bold">Date</td>
                                                <td className="font-bold">Payment Type</td>
                                                <td className="font-bold">Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredVendorPayments && filteredVendorPayments?.map((payment) => (
                                                <tr key={payment.id}>
                                                    <td>{payment.vendorid}</td>
                                                    <td>{payment.vendorname}</td>
                                                    <td>{payment.paymentdate}</td>
                                                    <td>
                                                        {payment.paymenttype}
                                                        {payment.chequenumber ? ' No. ' + payment.chequenumber : ''}
                                                        {payment.refnumber ? ' Ref. No. ' + payment.refnumber : ''}
                                                    </td>
                                                    <td>{payment.amountstatus}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <tr className=" text-center bg-gray-100 p-1 py-2 mb-10 text-center text-base text-black border-t border-b border-black uppercase w-full font-semibold" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <td className=" font-bold text-md text-center" colSpan={2}>
                                            Total Payments: {calculateTotalPayments(filteredVendorPayments)}
                                        </td>
                                    </tr>
                                    <tr className=" text-center h-10 font-bold mt-2">
                                        <td className=" font-bold text-lg border-t border-black text-center" colSpan={2}>
                                            Accountant
                                        </td>
                                    </tr>
                                </div>
                            </div>
                        </main>
                    </>
                )}

            </div>
        </>
    )
}

export default PaymentsReportPage
